export interface AnswerInterface {
  /**
   * 答题人ID
   */
  submitterId: number
  /**
   * 分配学案id
   */
  handoutId: number
  /**
   * 分配学案的目录id
   */
  outlineId: number
  /**
   * 题目id
   */
  questionId: number
  /**
   * 答案内容
   */
  value?: string[]
  /**
   * 是否已发布
   */
  isPublished?: boolean
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class Answer implements AnswerInterface {
  /**
   * 答题人ID
   */
  submitterId: number
  /**
   * 分配学案id
   */
  handoutId: number
  /**
   * 分配学案的目录id
   */
  outlineId: number
  /**
   * 题目id
   */
  questionId: number
  /**
   * 答案内容
   */
  value?: string[]
  /**
   * 是否已发布
   */
  isPublished?: boolean
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: AnswerInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      submitterId: _submitterId,
      handoutId: _handoutId,
      outlineId: _outlineId,
      questionId: _questionId,
      value: _value,
      isPublished: _isPublished,
      id: _id,
      schoolId: _schoolId,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.submitterId = _submitterId
    this.handoutId = _handoutId
    this.outlineId = _outlineId
    this.questionId = _questionId
    this.value = _value
    this.isPublished = _isPublished
    this.id = _id
    this.schoolId = _schoolId
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
